import '../../../scss/layout.scss'
import { Outlet } from "react-router-dom";
import Nav from "../../Nav";
import { useSelector } from "react-redux";
import TopPanel from "../../TopPanel";

const Content = () => {
    const menuList = useSelector(state => state.main);
    const userInfo = useSelector(state => state.login);

    return (
        <div className="page-wrap">
            <div className="page-aside">
                <Nav nav={[...menuList]}/>
            </div>
            <div className="page-container">
                <div className="page-top box-wrap-group page-sticky">
                    {/*<Header />*/}
                </div>
                <TopPanel userInfo={userInfo}/>

                <main className="page-content" style={{position: "relative"}}>
                    <div className="container">
                        <Outlet/>
                    </div>
                </main>

                <div className="page-bottom">
                    {/*<Footer />*/}
                </div>
            </div>
        </div>
    )
}

export default Content